import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { WidgetsModule } from './widgets/widgets.module';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    WidgetsModule
  ],
  exports: [WidgetsModule],
  declarations: []
})
export class BrdsModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/brds.module.ts